<template>
  <div class="form">
    <p class="form__title">{{ t('forms.reset') }}</p>
    <div class="form__inputs">
      <ui-input
        :type="'password'"
        :placeholder="t('fields.password')"
        :rules="[isPasswordValid]"
        v-model="password"
      />
      <ui-input
        :type="'password'"
        :placeholder="t('fields.passwordConfirm')"
        :rules="[compareStrings]"
        v-model="passwordConfirm"
      />
    </div>
    <ui-button
      :isDisabled="!isFormValid"
      @click="confirmResetPassword"
      :isLoading="isLoading"
    >
      {{ t('buttons.reset') }}
    </ui-button>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiInput from "@/components/ui/ui-input.vue";
import {isPasswordValid} from "@/core/rules/textFieldRules.js";
import {computed, ref} from "vue";
import {useAppStore} from "@/stores/app.js";
import UiButton from "@/components/ui/ui-button.vue";
import {Auth} from "@/core/api/auth.js";
import {ElNotification} from "element-plus";
import {useRoute, useRouter} from "vue-router";

const {t} = useI18n()
const route = useRoute()
const router = useRouter()
const appStore = useAppStore()

const token = computed(() => {
  return route.query.token
})
const uid = computed(() => {
  return route.query.uid
})

const password = ref('')
const passwordConfirm = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
    isPasswordValid(password.value) === true &&
    compareStrings(passwordConfirm.value) === true
  )
})

const compareStrings = (v) => {
  if (v === password.value) return true
  return t('errors.compare')
}

const confirmResetPassword = async () => {
  isLoading.value = true

  const res = await Auth.confirmResetPassword(uid.value, token.value, password.value, passwordConfirm.value)

  if (!res.errors) {
    appStore.setActiveState('signIn')

    ElNotification({
      dangerouslyUseHTMLString: true,
      message: t('popup.successNewPassword'),
      customClass: 'notification'
    })
  } else {
    ElNotification({
      dangerouslyUseHTMLString: true,
      message: res.errors[0].message,
      customClass: 'notification'
    })
  }

  isLoading.value = false
}
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  &__login {
    cursor: pointer;
    align-self: flex-start;
  }

  &__title {
    align-self: flex-start;
    font-family: Poppins, sans-serif;
    font-size: 30px;
    font-weight: 600;
    color: $main;
  }

  &__inputs {
    width: 100%;
    margin-block: 25px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
}
</style>